import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  userId: string | null;
  email: string | null;
  licenseStatus: 'none' | 'active' | 'revoked';
  expiresAt: number | null;

  setSession: (s: {
    token: string;
    userId: string;
    email: string;
    licenseStatus: 'none' | 'active' | 'revoked';
    expiresAt: number;
  }) => void;
  setLicenseStatus: (status: 'none' | 'active' | 'revoked') => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      userId: null,
      email: null,
      licenseStatus: 'none',
      expiresAt: null,

      setSession: (s) =>
        set({
          token: s.token,
          userId: s.userId,
          email: s.email,
          licenseStatus: s.licenseStatus,
          expiresAt: s.expiresAt,
        }),

      setLicenseStatus: (status) => set({ licenseStatus: status }),

      logout: () =>
        set({
          token: null,
          userId: null,
          email: null,
          licenseStatus: 'none',
          expiresAt: null,
        }),

      isAuthenticated: () => {
        const { token, expiresAt } = get();
        return !!token && !!expiresAt && expiresAt > Date.now();
      },
    }),
    { name: 'vg-auth' },
  ),
);
